export enum CancellationRequestStatus {
  InProgress = 'IN_PROCESS',
  Canceled = 'CANCELED',
  Rejected = 'REJECTED',
}
